<!-- Modal -->
<div *ngIf="isVisible" class="pb-two-link-modal-popup pb-fixed pb-inset-0 pb-flex pb-items-center pb-justify-center pb-z-[1001]">
  <div class="pb-shadow-lg pb-max-w-[60rem] pb-w-full pb-flex pb-flex-col lg:pb-overflow-hidden pb-modal-background pb-h-full lg:pb-h-auto pb-overflow-auto" [ngClass]="energySave ? 'pb-border pb-border-white' : ''">
    
    <!-- Header -->
    <div class="pb-flex pb-flex-col pb-gap-1 md:pb-gap-2">
      <div class="pb-flex pb-justify-end pb-pt-3 pb-px-4 md:pb-pt-5 md:pb-px-6">
        <button (click)="closeModal()" class="pb-cursor-pointer pb-icon-color-default hover:pb-scale-110">
          <i class="pb-icon pb-icon-check-x-dash pb-text-i-32 md:pb-text-i-56"></i>
        </button>
      </div>

      <div class="pb-flex pb-flex-row pb-justify-between pb-gap-1 md:pb-gap-2">
        <div class="pb-flex pb-flex-col pb-gap-2 md:pb-gap-2 pb-px-4 md:pb-px-7 pb-pb-5 md:pb-pb-[3.75rem]">
          <div *ngIf="rendering.fields?.ModalLabel.value" class="pb-text-xs-m lg:pb-text-md pb-font-bold">{{rendering.fields.ModalLabel.value}}</div>
          <h2 *ngIf="rendering.fields?.ModalTitle.value" class="pb-text-d-sm-m lg:pb-text-d-md pb-font-serif pb-text-color-brand lg:pb-whitespace-pre-wrap">{{rendering.fields.ModalTitle.value}}</h2>
          <h3 *ngIf="rendering.fields?.ModalSubtitle.value" class="pb-hidden md:pb-block pb-mt-4 lg:pb-whitespace-pre-wrap">{{rendering.fields.ModalSubtitle.value}}</h3>
        </div>
        <div class="pb-flex pb-justify-center lg:pb-max-w-[270px] lg:pb-mr-10">
          <ng-container *ngIf="rendering.fields?.ModalImage?.value?.src && !energySave">
            <img *ngIf="!energySave" offset="100" [defaultImage]="'images/default-image.png' | asset" [lazyLoad]="rendering.fields?.ModalImage?.value?.src" [alt]="rendering.fields?.ModalImage?.value?.alt" class="pb-hidden lg:pb-block">
          </ng-container>
          <ng-container *ngIf="rendering.fields?.EnergyModalImage?.value?.src && energySave">
            <img *ngIf="energySave" offset="100" [defaultImage]="'images/default-image.png' | asset" [lazyLoad]="rendering.fields?.EnergyModalImage?.value?.src" [alt]="rendering.fields?.EnergyModalImage?.value?.alt" class="!pb-block">
          </ng-container>
          <!-- <img offset="100" [defaultImage]="'images/default-image.png' | asset" [lazyLoad]="'https://webuat.piraeusbank.gr/-/jssmedia/Project/Piraeus/PiraeusBank/shared/Illustrations/awards.webp?iar=0&hash=4EDBD3F97C4E6A50C6933EC90A5FE284'" [alt]="rendering.fields?.ModalImage?.value?.alt"> -->
        </div>
      </div>
    </div>

    <!-- Boxes -->
    <div class="pb-grid pb-grid-cols-1 md:pb-grid-cols-2 pb-gap-2 md:pb-gap-6 pb-px-4 md:pb-px-7 pb-pb-5 md:pb-pb-7">
      <div class="pb-p-4 md:pb-p-5 pb-inner-box-bg pb-flex pb-flex-col pb-justify-between">
        <div>
          <h3 class="pb-text-h-xs-m lg:pb-text-h-sm pb-font-bold pb-mb-2 md:pb-mb-2 pb-text-color-brand">
            {{rendering.fields.LeftBoxTitle.value}}
          </h3>
          <p class="pb-text-xs-m lg:pb-text-sm pb-mb-4 md:pb-mb-4">
            {{rendering.fields.LeftBoxSubtitle.value}}
          </p>
        </div>
        <a *ngIf="rendering.fields?.LeftBoxLink?.value?.href != ''"
           hybridHref hreflang="{{language}}"
           href="{{rendering.fields?.LeftBoxLink?.value?.href}}"
           target="{{rendering.fields?.LeftBoxLink?.value?.target}}"
           attr.aria-label="{{rendering.fields?.LeftBoxLink?.value?.text}}"
           class="pb-btn pb-btn-primary lg:pb-w-fit">
          {{rendering.fields?.LeftBoxLink?.value?.text}}
          <i class="pb-icon pb-icon-arrow-right pb-text-i-24"></i>
        </a>
      </div>

      <div class="pb-p-4 md:pb-p-5 pb-inner-box-bg pb-flex pb-flex-col pb-justify-between">
        <div>
          <h3 class="pb-text-h-xs-m lg:pb-text-h-sm pb-font-bold pb-mb-2 md:pb-mb-2 pb-text-color-brand">
            {{rendering.fields.RightBoxTitle.value}}
          </h3>
          <p class="pb-text-xs-m lg:pb-text-sm pb-mb-4 md:pb-mb-4">
            {{rendering.fields.RightBoxSubtitle.value}}
          </p>
        </div>
        <a *ngIf="rendering.fields?.RightBoxLink?.value?.href != ''"
           hybridHref hreflang="{{language}}"
           href="{{rendering.fields?.RightBoxLink?.value?.href}}"
           target="{{rendering.fields?.RightBoxLink?.value?.target}}"
           attr.aria-label="{{rendering.fields?.RightBoxLink?.value?.text}}"
           class="pb-btn pb-btn-secondary lg:pb-w-fit">
          {{rendering.fields?.RightBoxLink?.value?.text}}
          <i class="pb-icon pb-icon-arrow-right pb-text-i-24"></i>
        </a>
      </div>
    </div>

    <!-- Footer -->
    <div class="pb-flex pb-items-center pb-gap-2 md:pb-gap-4 pb-px-4 md:pb-px-7 pb-pt-3 pb-pb-10 md:pb-py-5 pb-w-full pb-two-link-modal-footer pb-mt-auto pb-text-xs-m md:pb-text-md">
      <i *ngIf="rendering.fields?.ModalFooterIcon?.value?.name" class="pb-icon {{rendering.fields?.ModalFooterIcon?.value?.name}} pb-footer-icon-subtle-color pb-text-i-24 md:pb-text-i-32"></i>
      <div class="" [innerHTML]="rendering.fields?.ModalFooterText?.value | TrustHtml"></div>
    </div>
    
  </div>
</div>
